import type { IValidatedResponse } from '../../httpClient';
import { deleteRequest } from '../../httpClient';
import type { IIdAckResponse } from '../ack-schema';
import { idAckResponseSchema } from '../ack-schema';

export async function deletePersonApi(id: number): Promise<IValidatedResponse<IIdAckResponse>> {
  return deleteRequest<IIdAckResponse>({
    path: `/sys/people/v1/${id}`,
    schema: idAckResponseSchema,
  });
}
